<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <el-row>
        <el-col
          :span="24"
          class="scene_top"
          v-lazy:background-image="goodServiceImg.picture1"
        >
          <div class="scene_topContent">
            <h1>优质服务</h1>
            <p>HIGH-QUALITY SERVICES</p>
          </div>
        </el-col>
      </el-row>
      <!-- 服务体系 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space content_coreTechnology">
            <div class="title">
              <h3>服务体系</h3>
              <i class="lineTitel"></i>
            </div>
            <el-row>
              <div class="serviceSystem">
                <div class="content">
                  <h4>商业策划</h4>
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSPictureFive.png" /> -->
                    <img v-lazy="aboutImg.picture1" />
                    <p>
                      市场调研<br />竞争策略<br />建筑规划设计、优化<br />产品设计<br />产品再造<br />招商前置<br />运营前置<br />
                    </p>
                  </div>
                </div>
                <div class="content">
                  <h4>产品营建</h4>
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSPictureFour.png" /> -->
                    <img v-lazy="aboutImg.picture2" />

                    <p>
                      整购销售<br />整合营销<br />网络营销<br />移动客户端<br />区域行销<br />电话CALL客<br />中介联动<br />租金预测<br />品牌落位<br />
                    </p>
                  </div>
                </div>
                <div class="content">
                  <h4>专业招商</h4>
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSPictureThree.png" /> -->
                    <img v-lazy="aboutImg.picture3" />

                    <p>
                      业态规划<br />商家招商<br />主力商家<br />商家谈判<br />实现溢价<br />
                    </p>
                  </div>
                </div>
                <div class="content">
                  <h4>运营管理</h4>
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSPictureTwo.png" /> -->
                    <img v-lazy="aboutImg.picture4" />

                    <p>
                      统一包装<br />统一包租<br />商家调整<br />二次招商<br />新媒体营销<br />跨界营销<br />
                    </p>
                  </div>
                </div>
                <div class="content">
                  <h4>推广服务</h4>
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSPictureOne.png" /> -->
                    <img v-lazy="aboutImg.picture5" />

                    <p>
                      媒体策略<br />事件创造<br />形象推广<br />户外广告<br />促销策略<br />全方位设计<br />
                    </p>
                  </div>
                </div>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 主营业务 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space goodeServiceZhu">
            <div class="title">
              <h3>主营业务</h3>
              <i class="lineTitel"></i>
            </div>
            <el-row>
              <div class="serviceSystems">
                <div class="content">
                  <h4>销售服务</h4>
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSServeSix.png" /> -->
                    <img v-lazy="aboutImg.picture6" />

                    <p>代理销售<br />销售权收购<br />整购</p>
                  </div>
                </div>
                <div class="content">
                  <h4>产品营建</h4>
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSServeSeven.png" /> -->
                    <img v-lazy="aboutImg.picture7" />

                    <p>
                      输出产品理念和空间构建方案<br />与房企合作营建运营商业地产<br />
                    </p>
                  </div>
                </div>
                <div class="content">
                  <h4>专业招商</h4>
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSServeEight.png" /> -->
                    <img v-lazy="aboutImg.picture8" />

                    <p>公寓运营<br />商业街区运营<br /></p>
                  </div>
                </div>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 全链条解决能力 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space goodeServicelian">
            <div class="title">
              <h3>全链条解决能力</h3>
              <i class="lineTitel"></i>
            </div>
            <div class="tips">
              <p>蓝海购商业解决模式</p>
              <span>全链条一体化解决能力</span>
            </div>
            <el-row>
              <div class="serviceSystems">
                <div class="content">
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSServeNine.png" /> -->
                    <img v-lazy="aboutImg.picture9" />

                    <p>拿地建议</p>
                  </div>
                  <!-- <img src="~@/assets/images/IntelligentHub3.png" /> -->
                </div>
                <div class="content">
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSServeTen.png" /> -->
                    <img v-lazy="aboutImg.picture10" />

                    <p>定位咨询</p>
                  </div>
                  <!-- <img src="~@/assets/images/IntelligentHub3.png" /> -->
                </div>
                <div class="content">
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSServeTelve.png" /> -->
                    <img v-lazy="aboutImg.picture11" />

                    <p>招商运营</p>
                  </div>
                  <!-- <img src="~@/assets/images/IntelligentHub3.png" /> -->
                </div>
                <div class="content">
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSServeThreeten.png" /> -->
                    <img v-lazy="aboutImg.picture12" />

                    <p>运营优化</p>
                  </div>
                  <!-- <img src="~@/assets/images/IntelligentHub3.png" /> -->
                </div>
                <div class="content">
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSServeforty.png" /> -->
                    <img v-lazy="aboutImg.picture13" />

                    <p>销售增值</p>
                  </div>
                </div>
                <!-- <img src="~@/assets/images/BOSArrows.png" /> -->
                <img v-lazy="aboutImg.picture14" />
              </div>
            </el-row>

            <div class="title titleStyle">
              <h3>专业价值模型</h3>
              <i class="lineTitel"></i>
            </div>
            <el-row>
              <div class="goodServiceLast">
                <div class="contentValue contentValue1">
                  <p>蓝海购商业解决模式</p>
                  <div class="contentValueBox">
                    <!-- <img src="~@/assets/images/BOSServeOnes.png" /> -->
                    <img v-lazy="aboutImg.picture15" />

                    <p>代理销售业务<br />包销业务</p>
                  </div>
                </div>
                <div class="contentValue contentValue2">
                  <p>社区（体验式）商业</p>
                  <div class="contentValueBox">
                    <!-- <img src="~@/assets/images/BOSServeTwos.png" /> -->
                    <img v-lazy="aboutImg.picture16" />

                    <p>
                      定位咨询<br />产品设计和布局优化<br />业态布局<br />运营优化<br />招商执行<br />终端销售
                    </p>
                  </div>
                </div>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style>
.el-carousel__container {
  height: 625px !important;
}

.el-carousel__button {
  border-radius: 50%;
  width: 10px !important;
  height: 10px !important;
}

.el-carousel__indicator--horizontal {
  padding: 12px 21px 39px 0 !important;
}
</style>
<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  .scene_top {
    // background: url(~@/assets/images/BOSClassicCaseBackground.png) no-repeat;
    background-size: 100% 100%;
    height: 593px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      text-align: left;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        padding-bottom: 22px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      p {
        font-size: 20px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
        text-align: center;
      }
    }
  }

  //1 公共样式
  .content_space {
    // background: url(~@/assets/images/bg.png) no-repeat;
    // padding: 49px 261px 56px 260px;
    .title {
      font-size: 30px;
      font-family: MicrosoftYaHeiLight;
      font-weight: bold;
      color: #000000;
      h3 {
        font-size: 30px;
        margin-bottom: 25px;
        font-weight: 400;
        color: #333333;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 87px;
      }
    }
    .content {
      width: 304px;
      margin: auto;
      font-weight: 400;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        margin: 43px 0 44px 0;
      }
      p {
        font-size: 16px;
        font-family: MicrosoftYaHeiLight;
        line-height: 32px;
        height: 190px;
      }

      .el-button {
        margin-top: 23px;
        border-radius: 25px;
        a {
          text-decoration: none;
          color: #3d3d3d;
        }
      }

      .el-button:hover,
      .el-button:focus {
        background: #e9471a;
      }

      .el-button:hover a,
      .el-button:focus a {
        color: #fff;
      }
    }
  }

  //核心技术
  .content_coreTechnology {
    background: none;
    padding: 49px 260px 56px 259px;
    .title {
      padding-top: 30px;
      margin-bottom: 34px;
      h3 {
        margin-bottom: 0 !important;
      }
      .lineTitel {
        width: 76px;
        height: 5px;
        background: #a7823c;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }

    .serviceSystem {
      display: flex;
      justify-content: space-between;
      > div {
        width: 246px;
        height: 534px;
        margin-right: 43px;
        border: 1px solid #dddddd;
      }

      > div:last-of-type {
        margin-right: 0;
      }

      .content {
        h4 {
          font-size: 20px;
          font-family: MicrosoftYaHei;
          margin: 26px 0 20px 0;
        }
      }

      .content_coreTechnologyBox {
        img {
          width: 201px;
          height: 133px;
        }
      }
    }

    .content:hover {
      background: #27439f;
      color: #fff;
    }
  }

  //主营
  .goodeServiceZhu {
    background: #f6f6f6 !important;
    background: none;
    padding: 49px 260px 56px 259px;
    .title {
      padding-top: 30px;
      margin-bottom: 34px;
      h3 {
        margin-bottom: 0 !important;
      }
      .lineTitel {
        width: 76px;
        height: 5px;
        background: #a7823c;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }

    .serviceSystems {
      display: flex;
      justify-content: space-between;
      > div {
        width: 373px;
        height: 417px;
        margin-right: 141px;
        background: #fff;
      }

      > div:last-of-type {
        margin-right: 0;
      }

      .content {
        h4 {
          font-size: 20px;
          font-family: MicrosoftYaHei;
          margin: 26px 0 20px 0;
        }
      }
    }
  }

  //链条
  .goodeServicelian {
    background: url(~@/assets/images/BOSgoodServiceBackgroundTwo.png) no-repeat;
    padding: 49px 260px 56px 259px;
    .titleStyle {
      border-top: 1px #f6f6f6 solid;
      margin-top: 80px;
    }
    .title {
      padding-top: 30px;
      margin-bottom: 34px;
      h3 {
        margin-bottom: 0 !important;
      }
      .lineTitel {
        width: 76px;
        height: 5px;
        background: #a7823c;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }

    .tips {
      font-size: 20px;
      margin: 0 auto;
      margin-top: 38px;
      margin-bottom: 62px;
      line-height: 32px;
      span {
        font-weight: bold;
        color: #28449f;
      }
    }

    .serviceSystems {
      position: relative;
      display: flex;
      justify-content: space-between;
      > div {
        width: 100px;
        margin-right: 225px;
        text-align: left;
      }

      > div:last-of-type {
        margin-right: 0;
      }

      .content {
        p {
          height: auto;
          text-align: center;
        }
        img {
          max-width: 100px;
          max-height: 100px;
        }
        h4 {
          font-size: 20px;
          font-family: MicrosoftYaHei;
          margin: 26px 0 20px 0;
        }
      }
      > img {
        max-width: 1034px;
        max-height: 31px;
        position: absolute;
        left: 175px;
        top: 35px;
      }
    }

    .goodServiceLast {
      position: relative;
      display: flex;
      justify-content: center;
      .contentValue1 {
        background: url(~@/assets/images/BOSServeThee.png) no-repeat;
        > p {
          font-size: 20px;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #fefefe;
          margin: 39px 0 29px 0;
        }
        .contentValueBox {
          p {
            font-size: 20px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #fefefe;
            line-height: 32px;
            margin-top: 73px;
          }
          img {
            position: relative;
            right: 22px;
          }
        }
      }

      .contentValue2 {
        background: url(~@/assets/images/BOSServeBackgroundTwo.png) no-repeat;
        width: 480px;
        height: 497px;
        > p {
          font-size: 20px;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #fefefe;
          margin: 39px 0 29px 0;
        }
        .contentValueBox {
          p {
            font-size: 20px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #fefefe;
            line-height: 32px;
          }

          img {
            padding-left: 22px;
          }
        }
      }
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";
import goodServiceImg1 from "@/assets/images/BOSClassicCaseBackground.png";
import aboutImgOne from "@/assets/images/BOSPictureFive.png";
import aboutImgTwo from "@/assets/images/BOSPictureFour.png";
import aboutImgThree from "@/assets/images/BOSPictureThree.png";
import aboutImgFour from "@/assets/images/BOSPictureTwo.png";
import aboutImgFive from "@/assets/images/BOSPictureOne.png";
import aboutImgSix from "@/assets/images/BOSServeSix.png";
import aboutImgSeven from "@/assets/images/BOSServeSeven.png";
import aboutImgEight from "@/assets/images/BOSServeEight.png";
import aboutImgNine from "@/assets/images/BOSServeNine.png";
import aboutImgTen from "@/assets/images/BOSServeTen.png";
import aboutImgTelve from "@/assets/images/BOSServeTelve.png";
import aboutImgEleven from "@/assets/images/BOSServeThreeten.png";
import aboutImgThirteen from "@/assets/images/BOSServeforty.png";
import aboutImgFourteen from "@/assets/images/BOSArrows.png";
import aboutImgFifteen from "@/assets/images/BOSServeOnes.png";
import aboutImgSixteen from "@/assets/images/BOSServeTwos.png";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {
      tabIndex: "2",
      goodServiceImg: {
        picture1: goodServiceImg1,
      },
      aboutImg: {
        picture1: aboutImgOne,
        picture2: aboutImgTwo,
        picture3: aboutImgThree,
        picture4: aboutImgFour,
        picture5: aboutImgFive,
        picture6: aboutImgSix,
        picture7: aboutImgSeven,
        picture8: aboutImgEight,
        picture9: aboutImgNine,
        picture10: aboutImgTen,
        picture11: aboutImgTelve,
        picture12: aboutImgEleven,
        picture13: aboutImgThirteen,
        picture14: aboutImgFourteen,
        picture15: aboutImgFifteen,
        picture16: aboutImgSixteen,
      },
    };
  },
  methods: {},
  computed: {},
};
</script>